













import { Component, Prop, Vue } from 'vue-property-decorator';
import shapes from '@/common/utils/shapes';
import { RouteStop } from '@/api/types';
import { bus } from '@/services/busService';
import { InfoWindowReference } from '@/types/mapInfoWindow';
import { toLatLng } from '@/common/utils/googleMaps';

@Component
export default class extends Vue {
  @Prop({ default: 'black' })
  colour!: string;

  @Prop({ required: true })
  routeStop!: RouteStop;

  @Prop({ required: true })
  isVisible!: boolean;

  @Prop({ required: true })
  infoWindowReference!: InfoWindowReference;

  get simpleMarkerIcon(): object {
    return {
      path: shapes.MAP_MARKER,
      fillColor: this.colour,
      fillOpacity: 1,
      strokeWeight: 0.5,
      rotation: 0,
      scale: 2,
      labelOrigin: { x: 0, y: -11 }
    };
  }

  get routeStopLocation(): google.maps.LatLngLiteral {
    return toLatLng(this.routeStop.location);
  }

  private openMarkerInfoWindow(): void {
    bus.$emit('openStopMarkerInfo', this.routeStop, this.infoWindowReference);
  }
}
